
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Col, Container, Row,} from "reactstrap";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import SummaryService from "../../../services/summaryService";
import _ from "lodash";
import routeVisibleForRole from "../../../util/routeVisibleForRole";
import SummaryDetails from "./Details";
import FormInput from "../../../components/common/form/FormInput";
import moment from "moment";
import CompanyService from "../../../services/companyService";
import FormReactSelect from "../../../components/common/form/FormReactSelect";
import UtilService from "../../../services/utilService";
import ProjectService from "../../../services/projectService";
import SecurityService from "../../../services/securityService";
import ProjectCompanyService from "../../../services/projectCompanyService";
import AdminService from "../../../services/adminService";

class SummaryList extends React.Component {
    constructor(props) {
        super(props);
        
        // Calculate last 7 days including today
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6); // 6 days back + today = 7 days
        
        const filterDateFrom = sevenDaysAgo.toISOString().split('T')[0];
        const filterDateTo = today.toISOString().split('T')[0];
        
        this.state = {
            list: [],
            alert: null,
            filteredList: [],
            filterDateFrom: filterDateFrom,
            filterDateTo: filterDateTo,
            filterCompany: "",
            filterSharedWith: "",
            companiesForFilter: [],
            projectsForFilter: [],
            selectedCompany: {},
            selectedProject: {},
            companySelectKey: UtilService.uuidv4(),
            projectSelectKey: UtilService.uuidv4(),
            companyId: null,
            projectId: null,
            usersForFilter: [],
            allUsers: [], // Store all users fetched from API
            selectedUser: {},
            userId: null,
            userSelectKey: UtilService.uuidv4(),
            attendeesForSelection: [], // For passing to SummaryDetails components
            projectsForSelection: [], // For passing to SummaryDetails components
        };
        this.delete = this.delete.bind(this);
        this.notify = this.notify.bind(this);
    }

    componentDidMount() {
        console.log(this.props)
        this.populateSummaries();
        // Fetch users early (only if not ROLE_LEVEL1, ROLE_LEVEL2, ROLE_LEVEL3)
        if (!SecurityService.hasAnyRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
            this.populateUsers();
        }
        // Populate data for SummaryDetails components
        this.populateAttendeesForSelection();
        this.populateProjectsForSelection();
    };

    handleCompanyChange = (valueObj, event) => {
        console.log(valueObj);
        if (_.isNull(valueObj)) {
            this.setState({selectedCompany: {}, companyId: ""});
        } else {
            this.setState({selectedCompany: valueObj, companyId: valueObj.uniqueId});

        }
    };

    handleProjectChange = (valueObj, event) => {
        console.log(valueObj);
        if (_.isNull(valueObj)) {
            this.setState({selectedProject: {}, projectId: ""});
        } else {
            this.setState({selectedProject: valueObj, projectId: valueObj.uniqueId});
            ProjectCompanyService.listByProject(valueObj.uniqueId).then(response => {
                const companies = _.map(response, projectCompany => projectCompany?.company);
                this.setState({selectedCompany: {}, companiesForFilter: companies, companySelectKey: UtilService.uuidv4()});
            })

        }
    };

    handleUserChange = (valueObj, event) => {
        console.log(valueObj);
        if (_.isNull(valueObj)) {
            this.setState({selectedUser: {}, userId: null});
        } else {
            this.setState({selectedUser: valueObj, userId: valueObj.uniqueId});
        }
    };

    onChange = (event) => {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    populateCompanies =  () => {
        // Extract unique companies from all summaries in the date range (use 'list' not 'filteredList')
        const uniqueCompanies = _.uniqBy(_.map(this.state.list, "company"), "uniqueId");

        console.log("uniqueCompanies" ,uniqueCompanies);
        this.setState({companiesForFilter: uniqueCompanies, companySelectKey: UtilService.uuidv4()});
    }

    populateProjects = () => {
        // Extract unique projects from all summaries in the date range (use 'list' not 'filteredList')
        const allProjects = _.flatMap(this.state.list, 'sharedWithProjects');
        const uniqueProjects = _.uniqBy(_.compact(allProjects), 'uniqueId');
        
        // Apply role-based filtering for LEVEL1/2/3 users
        let filteredProjects = uniqueProjects;
        if (SecurityService.hasAnyRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
            let userId = localStorage.getItem("userId");
            filteredProjects = _.filter(uniqueProjects, project => {
                return _.some(project.sharedWith, { uniqueId: userId });
            });
        }
        
        console.log("Projects from summaries:", filteredProjects);
        this.setState({ projectsForFilter: filteredProjects, projectSelectKey: UtilService.uuidv4() });
    }

    populateUsers = () => {
        // Only fetch if we don't have users yet
        if (this.state.allUsers.length === 0) {
            AdminService.list().then((response) => {
                console.log("Users List...", response);
                // Access users from response.data (API response wrapper)
                const users = response.data || [];
                console.log("Users array:", users);
                // Store all users in state
                this.setState({allUsers: users}, () => {
                    // Filter users based on summaries
                    this.filterUsersBySummaries();
                });
            }).catch((error) => {
                console.error("Error fetching users:", error);
                this.setState({allUsers: [], usersForFilter: [], userSelectKey: UtilService.uuidv4()});
            });
        } else {
            // If users already loaded, just filter them
            this.filterUsersBySummaries();
        }
    }

    populateAttendeesForSelection = () => {
        AdminService.list().then((response) => {
            console.log("Attendees for Selection...", response);
            this.setState({attendeesForSelection: response.data || []});
        }).catch((error) => {
            console.error("Error fetching attendees:", error);
            this.setState({attendeesForSelection: []});
        });
    }

    populateProjectsForSelection = () => {
        ProjectService.list().then((response) => {
            console.log("Projects for Selection...", response);
            if(SecurityService.hasAnyRole(["ROLE_LEVEL1","ROLE_LEVEL2","ROLE_LEVEL3"])){
                let userId = localStorage.getItem("userId")
                const filteredProjects =  _.filter(response, project => {
                    return _.some(project.sharedWith, { uniqueId: userId });
                });
                this.setState({projectsForSelection: filteredProjects});
            } else {
                this.setState({projectsForSelection: response || []});
            }
        }).catch((error) => {
            console.error("Error fetching projects for selection:", error);
            this.setState({projectsForSelection: []});
        });
    }

    // New method to filter users based on summaries
    filterUsersBySummaries = () => {
        const {allUsers, list} = this.state;
        if (!allUsers.length || !list.length) {
            this.setState({usersForFilter: [], userSelectKey: UtilService.uuidv4()});
            return;
        }
        
        // Extract unique createdBy values from summaries
        const uniqueCreatedByIds = _.uniq(_.map(list, "createdBy")).filter(id => id);
        console.log("Unique Created By IDs from summaries:", uniqueCreatedByIds);
        
        // Filter users to only those who have created summaries
        const usersWhoCreatedSummaries = _.filter(allUsers, user => 
            _.includes(uniqueCreatedByIds, user.uniqueId)
        );
        
        console.log("Users who created summaries:", usersWhoCreatedSummaries);
        this.setState({usersForFilter: usersWhoCreatedSummaries, userSelectKey: UtilService.uuidv4()});
    }

    getDefaultDateRange = () => {
        // Last 7 days including today
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 6); // 6 days back + today = 7 days
        
        return {
            filterDateFrom: sevenDaysAgo.toISOString().split('T')[0],
            filterDateTo: today.toISOString().split('T')[0]
        };
    };

    applyFilter = () => {
        const {filterDateFrom, filterDateTo, companyId, projectId, userId} = this.state;
        console.log("Applying filter with state - ", this.state)

        // Fetch data from server with date filters
        SummaryService.list(filterDateFrom, filterDateTo).then((response) => {
            console.log("Summaries from server: ", response);
            let data = response;
            
            // Apply role-based filtering
            if (routeVisibleForRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
                let currentUserId = localStorage.getItem('userId')
                data = this.filterSummariesByUserId(data, currentUserId)
            }
            
            // Apply route-based filters
            const {companyUid} = this.props.match.params;
            if (companyUid !== undefined) {
                data = this.filterSummariesByCompany(data, companyUid)
            }
            const {projectUid} = this.props.match.params;
            if (projectUid !== undefined) {
                data = this.filterSummariesByProject(data, projectUid)
            }

            // Apply client-side filters (company, project, user)
            const filteredList = _.filter(data, (summary) => {
                const companyMatches = companyId
                    ? summary.companyUid === companyId
                    : true;

                const projectMatches = projectId
                    ? _.some(summary.sharedWithProjects, (sharedProject) =>
                        sharedProject.uniqueId === projectId
                    )
                    : true;

                const userMatches = userId
                    ? summary.createdBy === userId
                    : true;

                return companyMatches && projectMatches && userMatches;
            });

            this.setState({list: data, filteredList}, () => {
                this.populateCompanies();
                this.populateProjects();
                if (this.state.allUsers.length > 0 && !SecurityService.hasAnyRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
                    this.filterUsersBySummaries();
                }
            });
        });
    }

    clearFilter = () => {
        const { filterDateFrom, filterDateTo } = this.getDefaultDateRange();
        this.setState({
            filterDateFrom,
            filterDateTo,
            filterCompany: "",
            filterSharedWith: "",
            filterProjects: "",
            companyId: null,
            projectId: null,
            userId: null,
            selectedCompany: {},
            selectedProject: {},
            selectedUser: {},
            companySelectKey: UtilService.uuidv4(),
            projectSelectKey: UtilService.uuidv4(),
            userSelectKey: UtilService.uuidv4(),
            companiesForFilter: []
        }, () => {
            console.log(this.state)
            this.populateSummaries(filterDateFrom, filterDateTo);
        })
    }

    populateSummaries = (dateFrom = null, dateTo = null) => {
        // Use provided dates or fall back to state values
        const filterDateFrom = dateFrom !== null ? dateFrom : this.state.filterDateFrom;
        const filterDateTo = dateTo !== null ? dateTo : this.state.filterDateTo;
        
        SummaryService.list(filterDateFrom, filterDateTo).then((response) => {
            console.log("Summaries ; ", response);
            let finalList = response;
            
            if (routeVisibleForRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
                console.log("Filtering for User Roles")
                let currentUserId = localStorage.getItem('userId')
                console.log(currentUserId)
                finalList = this.filterSummariesByUserId(response, currentUserId)
                console.log(this.state.list)
                console.log(this.state.filteredList)
            }
            const {companyUid} = this.props.match.params;
            if (companyUid !== undefined) {
                console.log(`CompanyUid : ${companyUid}`)
                finalList = this.filterSummariesByCompany(finalList, companyUid)
                console.log(`company summary data : }`, finalList)
            }
            const {projectUid} = this.props.match.params;
            if (projectUid !== undefined) {
                console.log(`projectUid : ${projectUid}`)
                console.log(`data : ${response}`)
                finalList = this.filterSummariesByProject(finalList, projectUid)
                console.log(`project summary data : }`, finalList)
            }
            
            this.setState({list: finalList, filteredList: finalList}, () => {
                // Only filter users if we have them and user is not LEVEL1/2/3
                if (this.state.allUsers.length > 0 && !SecurityService.hasAnyRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"])) {
                    this.filterUsersBySummaries();
                }
                this.populateCompanies();
                this.populateProjects();
            });
        });
    }

    filterSummariesByUserId = (data, userId) => {
        console.log(data)
        const isRoleLevel3 = SecurityService.hasAnyRole(["ROLE_LEVEL3"]);
        return _.filter(data, summary => {
            // Check if user is in sharedWith (for all role levels)
            const isInSharedWith = _.some(summary.sharedWith, user => user.uniqueId === userId);
            // For ROLE_LEVEL3, also check if user created the summary
            const isCreator = isRoleLevel3 && summary.createdBy === userId;
            return isInSharedWith || isCreator;
        });
    };
    
    filterSummariesByCompany = (data, companyUid) => {
        console.log(`CompanyUid : ${companyUid}`)
        return _.filter(data, summary => summary.company.uniqueId === companyUid);
    };
    filterSummariesByProject = (data, projectUid) => {
        console.log(`projectUid : ${projectUid}`);
        return _.filter(data, summary =>
            summary?.sharedWithProjects?.some(project => project.uniqueId === projectUid)
        );
    };

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };


    delete(uniqueId) {
        this.setState({alert: null})
        SummaryService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            // Refresh with current date filters
            this.populateSummaries(this.state.filterDateFrom, this.state.filterDateTo);
        });
    }

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    };

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.delete(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };


    render() {
        let obj = this;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <SimpleHeader
                    name="List"
                    parentName="Summary"
                    heading="XareGrwoth"
                    // newBtnUrl="/admin/meetingReport/list"
                    // newBtnText="List All Meeting Reports"

                />
                {this.state.alert}
                <Container className="" fluid>
                    <Card>
                        <CardHeader className="border-0">
                            <Row className="align-items-center">
                                <div className="col">
                                    <h1 className="mb-0">Summaries</h1>
                                </div>
                            </Row>
                            <Row>
                                <p style={{fontStyle: "italic", color: "gray"}}>
                                    Use the filters below to narrow down your search results.
                                </p>
                            </Row>
                            <Row>
                                <Col md="2">
                                    <FormInput
                                        name="filterDateFrom"
                                        className="form-control-label"
                                        id="date"
                                        placeholder="inputPlaceHolder.meetingReport.date"
                                        type="date"
                                        onChange={this.onChange}
                                        value={this.state.filterDateFrom || ""}
                                        label="Date From"
                                    />
                                </Col>
                                <Col md="2">
                                    <FormInput
                                        name="filterDateTo"
                                        className="form-control-label"
                                        id="date"
                                        placeholder="inputPlaceHolder.meetingReport.date"
                                        type="date"
                                        onChange={this.onChange}
                                        value={this.state?.filterDateTo || ""}
                                        label="Date To"
                                    />
                                </Col>
                                {/*<Col md="2">
                                    <FormInput
                                        name="filterCompany"
                                        className="form-control-label"
                                        id="projectName"
                                        placeholder="Company"
                                        type="text"
                                        onChange={this.onChange}
                                        label="Company"
                                        value={this.state?.filterCompany || ""}
                                        // errorMsg={this.props.errorObj?.name || ""}
                                    />
                                </Col>*/}
                                <Col md="2">
                                    <FormReactSelect
                                        selectKey={this.state.projectSelectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="Project"
                                        name={"projectId"}
                                        onChange={this.handleProjectChange}
                                        optionValue={"uniqueId"}
                                        defaultValue={this.state.selectedProject}
                                        optionList={this.state.projectsForFilter}
                                        optionLabel={"name"}
                                        placeHolder="Select Project to filter"
                                        errorMsg={this.state?.errorObj?.projectId || ""}

                                    />
                                </Col>
                                <Col md="2">
                                    <FormReactSelect
                                        selectKey={this.state.companySelectKey}
                                        isMulti={false}
                                        className="form-control-label"
                                        isSearchable={true}
                                        label="inputLabel.contact.companyId"
                                        name={"companyId"}
                                        onChange={this.handleCompanyChange}
                                        optionValue={"uniqueId"}
                                        defaultValue={this.state.selectedCompany}
                                        optionList={this.state.companiesForFilter}
                                        optionLabel={"legalName"}
                                        placeHolder="inputPlaceHolder.contact.companyId"
                                        errorMsg={this.state?.errorObj?.companyId || ""}

                                    />
                                </Col>
                                {!SecurityService.hasAnyRole(["ROLE_LEVEL1", "ROLE_LEVEL2", "ROLE_LEVEL3"]) && (
                                    <Col md="2">
                                        <FormReactSelect
                                            selectKey={this.state.userSelectKey}
                                            isMulti={false}
                                            className="form-control-label"
                                            isSearchable={true}
                                            label="Created By"
                                            name={"userId"}
                                            onChange={this.handleUserChange}
                                            optionValue={"uniqueId"}
                                            defaultValue={this.state.selectedUser}
                                            optionList={this.state.usersForFilter}
                                            optionLabel={"fullName"}
                                            placeHolder="Select Creator to filter"
                                            errorMsg={this.state?.errorObj?.userId || ""}

                                        />
                                    </Col>
                                )}
                                {/*<Col md="2">
                                    <FormInput
                                        name="filterSharedWith"
                                        className="form-control-label"
                                        id="sharedWith"
                                        placeholder="Shared With"
                                        type="text"
                                        onChange={this.onChange}
                                        label="Shared With"
                                        value={this.state?.filterSharedWith || ""}
                                        // errorMsg={this.props.errorObj?.name || ""}
                                    />
                                </Col>*/}
                                {/*<Col md="2">
                                    <FormInput
                                        name="filterProjects"
                                        className="form-control-label"
                                        id="sharedWithProjects"
                                        placeholder="Project Name"
                                        type="text"
                                        onChange={this.onChange}
                                        label="Project"
                                        value={this.state?.filterProjects || ""}
                                        // errorMsg={this.props.errorObj?.name || ""}
                                    />
                                </Col>*/}
                                <Col sm={3} style={{marginTop: "30px"}}>
                                    <Button size="md" outline color="default" type="button"
                                            onClick={this.applyFilter}>
                                        Apply Filter
                                    </Button>
                                    <Button color="default" size="md" outline type="button"
                                            onClick={this.clearFilter}>
                                        Clear Filter
                                    </Button>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            <Row>

                                    {this.state.filteredList?.map((summary, index) => {
                                        return <>
                                        <Col md="12">
                                            <div key={index}>
                                                <SummaryDetails summary={summary} index={index + 1}
                                                                key={summary?.uniqueId}
                                                                delete={this.confirmDeleteAlert}
                                                                attendeesForSelection={this.state.attendeesForSelection}
                                                                projectsForSelection={this.state.projectsForSelection}
                                                />
                                            </div>
                                        </Col>
                                        </>

                                    })}

                            </Row>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default SummaryList;
